// Promise.withResolvers polyfill for older browsers
// This method was introduced in ES2023 and is not supported in older browsers
// Enhanced version with immediate execution and forced injection

// TypeScript declaration for Promise.withResolvers
declare global {
  interface PromiseConstructor {
    withResolvers<T = any>(): {
      promise: Promise<T>;
      resolve: (value: T | PromiseLike<T>) => void;
      reject: (reason?: any) => void;
    };
  }
}

// Enhanced polyfill implementation with immediate execution
(function() {
  'use strict';
  
  // Force check and inject the polyfill with better browser compatibility
  const globalScope = (function() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    if (typeof self !== 'undefined') return self;
    throw new Error('Unable to locate global object');
  })();
  
  const PromiseConstructor = globalScope.Promise;
  
  if (!PromiseConstructor || typeof PromiseConstructor.withResolvers !== 'function') {
    console.log('[POLYFILL] Injecting Promise.withResolvers polyfill for browser compatibility');
    
    const withResolversImpl = function <T = any>() {
      let resolve: (value: T | PromiseLike<T>) => void;
      let reject: (reason?: any) => void;
      
      const promise = new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
      });
      
      return {
        promise,
        resolve: resolve!,
        reject: reject!
      };
    };
    
    // Force assignment using multiple methods to ensure compatibility
    try {
      PromiseConstructor.withResolvers = withResolversImpl;
    } catch (e) {
      // Fallback for strict environments
      Object.defineProperty(PromiseConstructor, 'withResolvers', {
        value: withResolversImpl,
        writable: true,
        configurable: true
      });
    }
    
    // Verify the polyfill was applied
    if (typeof PromiseConstructor.withResolvers === 'function') {
      console.log('[POLYFILL] Promise.withResolvers polyfill successfully applied');
    } else {
      console.error('[POLYFILL] Failed to apply Promise.withResolvers polyfill');
    }
  } else {
    console.log('[POLYFILL] Promise.withResolvers is natively supported');
  }
})();

export {};